import { component } from 'picoapp';
import ClerkManager, { Config } from 'vendor/clerk';

export default component(async (node) => {
  const header:HTMLElement = document.querySelector('[data-search-open]');
  const overlay:HTMLElement = document.querySelector('[data-search-overlay]');
  const form:HTMLFormElement = document.querySelector('[data-search-form]');
  const productsList:HTMLElement = node.querySelector('[data-clerk-products]');
  const resultHitsCounters:NodeListOf<HTMLElement> = node.querySelectorAll('[data-hits]');
  const categoriesList:HTMLElement = node.querySelector('[data-clerk-categories]');
  const showResultsButtons:NodeListOf<HTMLElement> = node.querySelectorAll('[data-show-results]');

  const ClerkConfig:Config = {
    api_key: window.theme.clerkApiKey,
    header,
    form,
    productsList,
    categoriesList,
    resultHitsCounters,
    showResultsButtons,
    overlay,
  };

  const Clerk = new ClerkManager(ClerkConfig);
  Clerk.attachListeners();

  document.addEventListener('search:query', async (e:CustomEvent) => {
    if (e.detail.query !== '') {
      await Clerk.search([
        {
          url: 'search/predictive',
          type: 'predictive',
          body: {
            query: e.detail.query,
            limit: 6,
            attributes: ['id', 'image', 'url', 'name', 'price', 'tags'],
            labels: ['predictive search'],
          },
        },
        // TEMP DISABLED
        // TODO: clerk-categories-fix
        // TODO: Customer needs to decide how this should work
        // NOTE: Also commented some related code in /sections/header.liquid #L191
        // {
        //   url: 'search/categories',
        //   type: 'categories',
        //   body: {
        //     query: e.detail.query,
        //     limit: 10,
        //   },
        // },
      ]).then((results) => {
        // TODO: clerk-categories-fix
        // Clerk.buildCategoriesHTML(results.find((result) => result.custom_type === 'categories'));
        Clerk.buildPredictiveHTML(results.find((result) => result.custom_type === 'predictive'));

        node.hidden = false;
        header.classList.add('rounded-b-none');
      });
    } else {
      node.hidden = true;
      header.classList.remove('rounded-b-none');
    }
  });

  document.addEventListener('search:closed', () => {
    node.hidden = true;
  });

  document.addEventListener('search:opened', () => {
    if (!node.hidden) {
      header.classList.add('rounded-b-none');
    }
  });
});
